export default class Drag
    {
    constructor(navMenu,dragItem,container,numberOfSlides, windowW)
        {
        this.dragItem= document.querySelector(dragItem);
        this.container= document.querySelector(container);   
        this.active = false;
        this.currentX=0;
        this.finalPageX=0;
        this.initialX=0;
        this.initialPageX=0;
        this.xOffset = 0;
        this.navMenu = document.querySelector(navMenu);
        this.windowW = windowW;
        this.windowC = windowW/2;
        this.numberOfSlides =  numberOfSlides // needed to calculate initial offset
        this.centerSlide = Math.round(this.numberOfSlides /2)
        this.initALLEvents();
        }

    initDragableVars= () => 
        {
        this.windowW = window.innerWidth
        this.windowC = this.windowW/2
        this.dragItem.style.width = this.windowW * (this.numberOfSlides+1) +"px"             // this is needed or will need to manually use css width 
        }

    resetDrag=()=>
        {
        this.windowW = window.innerWidth
        this.windowC = this.windowW/2
        this.dragItem.style.width = this.windowW * (this.numberOfSlides+1) +"px"             // this is needed or will need to manually use css width 
        const pos = Math.round(this.xOffset / this.windowW);                                 // a hack  to reposition to current room when resizing
        // let navPos = ((pos -2) * -1 ) +1
        // just in case
        // if(navPos <=1)
        //     {navPos=1}                                                                                       
        // else if(navPos >=5)
        //     {navPos=5}
        // document.querySelector("nav li:nth-child("+ navPos+") a").click();
        }

    setTranslate = (xPos, el) => 
        {el.style.transform = "translate3d(" + xPos + "px, 0 , 0)"}

    dragStart = (e) => 
        {
        e.stopPropagation();
        this.dragItem.classList.add("grabbing");
        if(e.type === "touchstart")                                             //mobile touch
            {this.initialX = e.touches[0].clientX - this.xOffset; this.initialPageX = e.changedTouches[0].pageX}
        else                                                                    //desktop drag
            {this.initialX = e.clientX - this.xOffset           ; this.initialPageX =e.pageX}



        this.active = e.target === this.dragItem
        }

    dragEnd = (e) => 
        {
        e.stopPropagation();
        ///////////////////////////////////////////////////////////
        if(e.type === "touchend")                                             //mobile touch
            {this.finalPageX = e.changedTouches[0].pageX}
        else                                                                    //desktop drag
            {this.finalPageX = e.pageX;}
        ///////////////////////////////////////////////////////////
        const pos = Math.round(this.xOffset / this.windowW);
        const totalPixelsMoved = this.xOffset   - (this.windowW * pos);
        const direction = this.finalPageX - this.initialPageX < 0 ? -1 : 1;
        let nextPos = pos + direction ;

        if(Math.abs( totalPixelsMoved )> 50)                //minimum travel to make drag work
            { 
            // add limits
            if(nextPos >=2)
                {nextPos=2}
            else if(nextPos <= -2)
                {nextPos= -2}

            this.xOffset = (nextPos) *  this.windowW  
            this.setTranslate(this.xOffset, this.dragItem)
            this.highlightPageLink();
            this.activateHoversAfterDrag() // for mobile after dragging
            }

        this.dragItem.classList.remove("grabbing");
        this.initialX = this.currentX
        this.active = false;
        //////////////////////////////////////////////////////////////////////////
        let navNextScrollPos = Math.floor(  Math.abs( (this.xOffset / this.windowW ) -2) +1   )    //  scroll top nav on mobile
        console.log(navNextScrollPos)
            if(navNextScrollPos <1){navNextScrollPos=1}
            if(navNextScrollPos >5){navNextScrollPos=5}

        document.querySelector("nav li:nth-child("+ navNextScrollPos+") a").click();
        // let navFirstPos = 130;
        // let nexNavtPos = navFirstPos + (navNextScrollPos *160)
        // document.querySelector('.nav-wrap').scrollTo(nexNavtPos,0)
        
        }

        
    drag = (e) => 
        {
        e.stopPropagation();
        const pos = Math.round(this.xOffset / this.windowW);
        //console.log("initial: "+ this.initialX)
        if (this.active ) 
            {
            e.type === "touchmove" ? (this.currentX = e.touches[0].clientX - this.initialX ) : (this.currentX = e.clientX - this.initialX )
            this.xOffset = this.currentX
            this.setTranslate(this.currentX, this.dragItem)
            }
        }

    initALLEvents= function()
        {
        let navLinks =  this.navMenu.querySelectorAll('li a')
        for (let i=0; i< navLinks.length;i++)
            {navLinks[i].addEventListener("click", this.navClick, false)}
        
        document.body.addEventListener("touchstart", this.dragStart, false)
        document.body.addEventListener("touchend", this.dragEnd, false)
        document.body.addEventListener("touchmove", this.drag, false)
        document.body.addEventListener("mousedown", this.dragStart, false)
        document.body.addEventListener("mouseup", this.dragEnd, false)
        document.body.addEventListener("mousemove", this.drag, false)
        window.addEventListener("resize", this.resetDrag, true)
        this.initDragableVars()
        }

    highlightPageLink=()=>
        {
        const pos = Math.round(this.xOffset / this.windowW);
        const childElIndex = this.centerSlide - pos;
        const children = this.dragItem.querySelectorAll('.page')
        document.body.classList = children[childElIndex].getAttribute('id')
        }

    navClick=(e)=>
        {
        // this is needed because the slides are centered 
        // the middle slide is index(0) 
        // slides to the left are negative (-2,-3 -4 etc)
        // and slides to the right have a positive index (2,3,4 etc)
        let linkIndex = e.target.getAttribute('data-index');
        let slidePosition = this.centerSlide - linkIndex 
        this.xOffset= slidePosition * this.windowW  //SNAPING to closest slide when releasing drag       
        this.setTranslate(this.xOffset, this.dragItem)
        }

    activateHoversAfterDrag =()=>
        {
        const products = document.querySelectorAll(".roomObject") 
        for(let i=0; i< products.length; i++)
                        {products[i].classList.add("hover")}
        
        // make products ready for next animation (hover or page transition)
        setTimeout(
            function() {
                for(let i=0; i< products.length; i++) {products[i].classList.remove("hover")}
            }, 2000);
        }


    }
